const VERSION = typeof "3.4.15" !== 'undefined' ? "3.4.15" : 'latest';
export const PLYLoader = {
  name: 'PLY',
  id: 'ply',
  module: 'ply',
  shapes: ['mesh', 'gltf', 'columnar-table'],
  version: VERSION,
  worker: true,
  extensions: ['ply'],
  mimeTypes: ['text/plain', 'application/octet-stream'],
  text: true,
  binary: true,
  tests: ['ply'],
  options: {
    ply: {}
  }
};
export const _typecheckPLYLoader = PLYLoader;
//# sourceMappingURL=ply-loader.js.map